export default [
	{
		code: 'STNL',
		name: 'Single-Tenant',
	},
	{
		code: 'MT',
		name: 'Multi-Tenant',
	},
    {
        code: 'Other',
        name: 'Other',
    },
]